import { utils, writeFile, read } from "xlsx";

/**
 * Start
 * @func exportExcel
 * @desc export data to excel format
 * @author izeberg
 * @param {Array} data - ข้อมูลที่จะ export ([{},{},{}])
 * @param {Array} header - column ของตาราง excel ที่ต้องตรงกับ key ใน data (["", "", ""])
 * @param {string} fileName - ชื่อไฟล์ที่ทำการ export ("HelloWorld")
 * @returns undefined
 */
export const exportExcel = (data = [], header = [], fileName = "export") => {
    if (data?.length && header?.length) {
        const ws = utils.json_to_sheet(data, { header, skipHeader: false });
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws);
        writeFile(wb, `${fileName}.xlsx`);
        return true;
    }
    return false;
};
/** End @func exportExcel */

/**
 * Start
 * @func importExcel
 * @desc export data to excel format
 * @author izeberg
 * @param {Array} data - ข้อมูลที่จะ export ([{},{},{}])
 * @param {Array} header - column ของตาราง excel ที่ต้องตรงกับ key ใน data (["", "", ""])
 * @param {string} fileName - ชื่อไฟล์ที่ทำการ export ("HelloWorld")
 * @returns undefined
 */
export const importExcel = file => {
    if (file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = e => {
                const data = e.target.result;
                const workbook = read(data, { type: "file" });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = utils.sheet_to_json(worksheet);
                resolve(json);
            };
            reader.readAsArrayBuffer(file);
            reader.onerror = reject;
        });
    }
    return null;
};
/** End @func importExcel */
